import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatCheckboxField } from '@blocks-react/components/CheckboxField';
import { useCheckboxController } from '../../../hooks/form-controllers';
import styles from '../DealerLocator.module.scss';
const TERMS_CHECKBOX_ID = 'termsChecked';
export const DealerLocatorTermsCheckbox = ({ children, title, label, isDisabled, }) => {
    const { booleanCheckboxField } = useCheckboxController({
        name: TERMS_CHECKBOX_ID,
        rules: { required: true },
    });
    return (_jsx("div", { className: "mt-2 mb-4", children: _jsxs(CatCheckboxField, { ...booleanCheckboxField, disabled: isDisabled, children: [_jsxs("div", { className: "cat-u-theme-typography-label", children: [title, !!label && (_jsx("span", { className: styles['terms-checkbox-label'], children: label }))] }), _jsx("span", { slot: "field-note", children: children })] }) }));
};
